import { Search } from "@mui/icons-material";
import { FC } from "react";
import { components, ControlProps } from "react-select";

import { blueGreyMui } from "@ryde/theme";

export const FilterSelectControl: FC<ControlProps> = ({
  children,
  ...props
}) => {
  return (
    <components.Control {...props}>
      <Search style={{ color: blueGreyMui._300 }} />
      {children}
    </components.Control>
  );
};
